// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubscriptionTerms_CurrentResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * SubscriptionTerms_CurrentResponse — the agreement a franchise is asked to
 * sign: the live version for the PLAN it is subscribing to, rendered in the
 * variant closest to the reader's own language.
 *
 * `versao` and `content_sha256` describe what was agreed; `language` says
 * which translation was actually shown, which may be a fallback.
 *
 * `accepted` says whether THIS franchise already signed THIS version. It is
 * deliberately version-specific: having signed a retired document is not
 * having accepted the live one.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubscriptionTerms_CurrentResponseDados {
term_id: number
titulo: string
versao: string
plan_id: number
plano_nome: string
language: string
variant_id: number
conteudo: string
content_sha256: string
accepted: boolean
accepted_at: string
}

export type SubscriptionTerms_CurrentResponse = ApiResponse<SubscriptionTerms_CurrentResponseDados>;

registerResponseContract('SubscriptionTerms_CurrentResponse', {
  term_id:        { type: 'number',  required: true },
  titulo:         { type: 'string',  required: true },
  versao:         { type: 'string',  required: true },
  plan_id:        { type: 'number',  required: true },
  plano_nome:     { type: 'string',  required: true },
  language:       { type: 'string',  required: true },
  variant_id:     { type: 'number',  required: false },
  conteudo:       { type: 'string',  required: true },
  content_sha256: { type: 'string',  required: true },
  accepted:       { type: 'boolean', required: true },
  accepted_at:    { type: 'string',  required: false },
})
